/** Helpers financiers modal détail commande produit (partagés commerçant / plateforme). */

export const isCommandePaiementEnLigne = (cmd) =>
  cmd?.modePaiement === 'enligne' ||
  ['paypal', 'applepay', 'googlepay'].includes(String(cmd?.modePaiement || '').toLowerCase());

export function getCommandeSoldeRemboursable(cmd) {
  const paiements = cmd?.paiements || [];
  const encaisse = paiements
    .filter((p) => p.statutPaiement === 'VALIDE' && Number(p.montant) > 0)
    .reduce((s, p) => s + Number(p.montant), 0);
  const rembourse = Math.abs(
    paiements
      .filter((p) => p.statutPaiement === 'REMBOURSE' && Number(p.montant) < 0)
      .reduce((s, p) => s + Number(p.montant), 0),
  );
  return Math.round((encaisse - rembourse) * 100) / 100;
}

export function hasStripePaymentIntent(cmd) {
  return (cmd?.paiements || []).some(
    (p) =>
      p.statutPaiement === 'VALIDE' &&
      Number(p.montant) > 0 &&
      p.providerTransactionId &&
      String(p.providerTransactionId).startsWith('pi_'),
  );
}

export function parseSavReference(reference) {
  if (!reference) return null;
  if (typeof reference === 'object') return reference;
  try {
    return JSON.parse(reference);
  } catch {
    return null;
  }
}
